import { useTranslation } from 'react-i18next'
import styles from './CourseResultBadgeTooltipContent.module.scss'

export const CourseResultBadgeTooltipContent = ({
  grade,
  isPassed,
  state,
  score,
  showPassed,
}: {
  grade?: string
  isPassed?: boolean
  state?: string
  score?: string | null
  showPassed?: boolean
}) => {
  const { t } = useTranslation()

  if (!grade && !isPassed && !state && !score) {
    return null
  }

  const passedStatus = showPassed ? `(${t(isPassed ? 'Passed' : 'Failed')})` : ''
  return (
    <div className={styles.CourseResultBadgeTooltipContent}>
      {state && (
        <>
          {t('courseCard.state')}: {state} {passedStatus}
          <br />
        </>
      )}
      {grade && (
        <>
          {t('courseCard.grade')}: {grade}
          <br />
        </>
      )}
      {/* somewhere upper score is -, is too much to refactor all chain to proper reusable design */}
      {score && score !== '-' && (
        <>
          {t('courseCard.score')}: {score}
        </>
      )}
    </div>
  )
}
